import React from 'react';
import * as styles from './styles.css';
import { Rechart } from '../Rechart';
import { LinkButton, TDeviceType } from '@cian/ui-kit';
import { useLinkButtonProps } from 'shared/hooks';
import { LK_LINK, PRICE_PROMO_LINK } from 'shared/constants/links';
import { clsx } from 'clsx';
import { NBSP } from 'shared/constants/symbols';

export interface ILimitPromoProps {
  numberInput: JSX.Element;
  limitValue: number;
  device: TDeviceType;
  btnPricesIsDisabled: boolean;
}

export const LimitPromo: React.FC<ILimitPromoProps> = ({ numberInput, limitValue, device, btnPricesIsDisabled }) => {
  const linkButtonProps = useLinkButtonProps();

  return (
    <div className={clsx(styles['container'], styles[device])}>
      <div className={styles['title']}>Определите лимит на{NBSP}продвижение</div>
      <div className={styles['content']}>
        <div className={styles['control-block']}>
          <ul className={styles['list']}>
            <li>Чем выше лимит, тем больше уникальных просмотров вы получите</li>
            <li>Оцените точный эффект от продвижения в прозрачной статистике просмотров объявлений</li>
          </ul>
          {numberInput}
        </div>
        <Rechart limitValue={limitValue} device={device} />
      </div>
      <div className={styles['btns']}>
        <div className={styles['btn-container']}>
          <LinkButton {...linkButtonProps} href={LK_LINK} target="_blank" rel="noopener noreferrer">
            Подключить
          </LinkButton>
        </div>
        {!btnPricesIsDisabled && (
          <div className={styles['btn-container']}>
            <LinkButton {...linkButtonProps} theme="fill_secondary" href={PRICE_PROMO_LINK}>
              Тарифы на продвижение с 20 апреля
            </LinkButton>
          </div>
        )}
      </div>
    </div>
  );
};
